import React from 'react'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import AddIcon from '@mui/icons-material/Add'

// AddSelectionButton is the green circular (+) that takes what is ticked in a
// variable tree and adds it to a target: the spec editor's filter and weight,
// the construct builder's groups. Green while there is a selection to add;
// grey and disabled while there is none (a target that hides instead simply
// doesn't render it).
export interface AddSelectionButtonProps {
  onClick: () => void
  // The accessible name, e.g. "Add filter" or "Add to group 2".
  label: string
  tooltip?: string
  active?: boolean
}

export const AddSelectionButton: React.FC<AddSelectionButtonProps> = ({ onClick, label, tooltip, active = true }) => {
  const button = (
    <IconButton
      size="small"
      onClick={onClick}
      disabled={!active}
      aria-label={label}
      sx={active ? {
        backgroundColor: 'success.main',
        color: 'white',
        width: 28,
        height: 28,
        '&:hover': { backgroundColor: 'success.dark' },
      } : {
        color: 'text.secondary',
        width: 28,
        height: 28,
      }}
    >
      <AddIcon sx={{ fontSize: 18 }} />
    </IconButton>
  )
  if (!tooltip) return button
  return (
    <Tooltip title={tooltip}>
      <span>{button}</span>
    </Tooltip>
  )
}

export default AddSelectionButton
